import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=25127a2d&scoped=true"
import script from "./PersonCenter.vue?vue&type=script&lang=js"
export * from "./PersonCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=25127a2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_c6nu2kfme4k2fztecbunkha7um/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25127a2d",
  null
  
)

export default component.exports